const formEquipmentActions = {
  notFoundActions: 'Nenhuma ação encontrada',
  loadMoreButtonText: 'Mostrar mais',
};

export default formEquipmentActions;
